export default "__VITE_ASSET__bbaa0093__"